import { Button, Col, Flex, Form, Input, Row, theme, notification } from 'antd';
import React, {useState } from 'react';
import UserProfileAPI from '../../../restAPI/UserProfileAPI';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../redux/slices/authSlice';

export default function ChangePassword() {
    const [changePasswordForm] = Form.useForm();
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const { companyId, token, userId } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const [isEnabledSaveButton, setIsEnabledSaveButton] = useState(false);
    const [isSaveButtonLoading, setIsSaveButtonLoading] = useState(false);

    const [api, contextHolder] = notification.useNotification();

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const validateConfirmPassword = (changePasswordForm) => {
        const newPasswordValue = changePasswordForm.getFieldValue('newPassword');
        const confirmPasswordValue = changePasswordForm.getFieldValue('confirmPassword');

        if (confirmPasswordValue && newPasswordValue !== confirmPasswordValue) {
            changePasswordForm.setFields([
                {
                    name: 'confirmPassword',
                    errors: ['Passwords do not match.'],
                },
            ]);
        } else {
            changePasswordForm.setFields([
                {
                    name: 'confirmPassword',
                    errors: [],
                },
            ]);
        }
    };

    function hasSequentialChars(value) {
    for (let i = 0; i < value.length - 2; i++) {
        const first = value.charCodeAt(i);
        const second = value.charCodeAt(i + 1);
        const third = value.charCodeAt(i + 2);
        if (
        second === first + 1 &&
        third === second + 1
        ) {
        return true;
        }
        else  if (
        second === first - 1 &&
        third === second - 1
        ) {
        return true;
        }
    }
    return false;
    }

    const fieldValidator = (fieldName) => (_, value) => {
        const errors = [];

        // Handle empty field
        if (!value) {
            errors.push(`${fieldName} is required.`);
        } else {
            // Password-specific validations
            if (fieldName === 'New password') {
                // if (/(\w)\1{1,}/.test(value)) {
                //     errors.push(`${fieldName} cannot have more than 2 sequential characters.`);
                // }
                if (hasSequentialChars(value)) {
                    errors.push(`${fieldName} cannot have sequential characters like 'abc', '123', 'xyz'.`);
                }
                if (!/[A-Z]/.test(value)) {
                    errors.push(`${fieldName} must contain at least 1 uppercase character.`);
                }
                if (!/[a-z]/.test(value)) {
                    errors.push(`${fieldName} must contain at least 1 lowercase character.`);
                }
                if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
                    errors.push(`${fieldName} must contain at least 1 special character.`);
                }
                if (!/[0-9]/.test(value)) {
                    errors.push(`${fieldName} must contain at least 1 numeric character.`);
                }
                if (value.length < 8) {
                    errors.push(`${fieldName} must be at least 8 characters.`);
                }
                if (value.length > 32) {
                    errors.push(`${fieldName} cannot exceed 32 characters.`);
                }
                if (value === changePasswordForm.getFieldValue('currentPassword')) {
                    errors.push(`${fieldName} cannot be the same as the current password.`);
                }

                // Revalidate confirm password
                validateConfirmPassword(changePasswordForm);
            }

            if (fieldName === 'Confirm password') {
                const newPassword = changePasswordForm.getFieldValue('newPassword');
                if (value !== newPassword) {
                    errors.push('Passwords do not match.');
                }
            }
        }

        // Reject with line breaks (displayed correctly by AntD)
        return errors.length
            ? Promise.reject(new Error(errors.join('\n')))
            : Promise.resolve();
    };


    const handleChangePassword = async () => {
        setIsSaveButtonLoading(true)
        try {
            const tempValidation = await changePasswordForm.validateFields();
            const changePasswordPayload = {
                currentPassword: tempValidation.currentPassword,
                newPassword: tempValidation.newPassword
            }
            const response = await UserProfileAPI.changeUserPassword(changePasswordPayload, userId, companyId, token);
            if (response.status === 200) {
                openNotificationWithIcon('success', 'Password Change Successfull', 'Your password has been changed successfully. Please log in with your new password.', 'bottomLeft');
                setTimeout(async () => {
                    try {
                        await AuthRestAPI.logout(companyId, token);
                    } catch (_) {
                        // Ignore logout API errors and continue local logout.
                    }
                    dispatch(logout());
                    navigate('/login')
                }, 1000)
            }
        } catch (error) {
            console.log('Error in change password :', error);
            if (error.response) {
                openNotificationWithIcon('error', 'Password Change Failed', `${error?.response?.data?.message}`, 'bottomLeft');
            } else if (error instanceof Error) {
                // If it's not a validation | other internal error
                openNotificationWithIcon('error', 'Password Change Failed', 'There was an error with changing your password. Please check the entered details.', 'bottomLeft');
            }
            // else {
            //     openNotificationWithIcon('success', 'Paasowrd Change Failed', `There was an error with changing your password.`, 'bottomLeft');
            // }
        } finally {
            setIsSaveButtonLoading(false)
        }
    }

    const handleButtonCancle = async () => {
        await changePasswordForm.resetFields()
    }


    return (
        <>
            <div style={{
                margin: '16px',
                padding: '8px 12px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Flex justify='flex-start' align='center' gap={16}>
                    <span>Change Password</span>
                </Flex>
            </div>
            <div style={{
                margin: '16px',
                padding: '24px 12px',
                // minHeight: '70svh',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Form layout="vertical" form={changePasswordForm} autoComplete='off'
                >
                    <input
                        type="text"
                        name="fakeusernameremembered"
                        autoComplete="username"
                        style={{ display: 'none' }}
                        />
                        <input
                        type="password"
                        name="fakepasswordremembered"
                        autoComplete="current-password"
                        style={{ display: 'none' }}
                    />
                    <Row gutter={16}>
                        <Col lg={12} md={24} sm={24} offset={6}>
                            <Form.Item label="Current Password" name="currentPassword" rules={[
                                {
                                    required: true,
                                    message: 'Current password is required.'
                                }
                            ]}>
                                <Input.Password 
                                    name='CurrentPassword' 
                                    placeholder='Current Password' 
                                    autoComplete='off'
                                    readOnly
                                    onFocus={(e) => e.target.removeAttribute('readonly')}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} md={24} sm={24} offset={6}>
                            <Form.Item
                                label="New Password"
                                name="newPassword"
                                required
                                rules={[{ validator: fieldValidator('New password') }]}
                                style={{ whiteSpace: 'pre-line' }} // enables \n line breaks in error message
                                >
                                <Input.Password
                                    placeholder="New Password"
                                    autoComplete="off"
                                    readOnly
                                    onFocus={(e) => e.target.removeAttribute('readonly')}
                                />
                                </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} md={24} sm={24} offset={6}>
                            <Form.Item
                                label="Confirm Password"
                                name="confirmPassword"
                                required
                                rules={[{ validator: fieldValidator('Confirm password') }]}
                                style={{ whiteSpace: 'pre-line' }}
                                >
                                <Input.Password
                                    placeholder="Confirm Password"
                                    autoComplete="off"
                                    readOnly
                                    onFocus={(e) => e.target.removeAttribute('readonly')}
                                />
                                </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Flex align='center' justify='flex-end' gap={16}>
                    <Button type="default" onClick={() => { handleButtonCancle() }}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleChangePassword()}
                        loading={isSaveButtonLoading}
                        disabled={isSaveButtonLoading}
                    // disabled={!isEnabledSaveButton}
                    >
                        Save
                    </Button>
                </Flex>
            </div>
            {contextHolder}
        </>
    );
}
